import React, { useState } from 'react';
import { Form, Input, Button, message, Tabs } from 'antd';
import { UserOutlined, LockOutlined, PhoneOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { setUser } from '../redux/userSlice';
import { authAPI } from '../services/api';

const { TabPane } = Tabs;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);
  const dispatch = useDispatch();

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await authAPI.login({
        username: values.username,
        password: values.password
      });
      
      if (response.data.access_token) {
        // 存储token和用户信息
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('userInfo', JSON.stringify(response.data.user));
        // 设置用户信息
        dispatch(setUser({
          token: response.data.access_token,
          userInfo: response.data.user
        }));
        message.success('登录成功');
      } else {
        message.error('登录失败，请检查用户名和密码');
      }
    } catch (error) {
      console.error('登录错误:', error);
      message.error('登录失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (values) => {
    setRegisterLoading(true);
    try {
      console.log('注册请求数据:', values);
      console.log('API基础URL:', 'http://127.0.0.1:5000/api');
      const response = await authAPI.register({
        username: values.username,
        password: values.password,
        phone: values.phone,
        role_id: parseInt(values.role_id) // 确保role_id是数字类型
      });
      console.log('注册响应:', response);
      message.success('注册成功，请登录');
    } catch (error) {
      console.error('注册错误:', error);
      console.error('错误详情:', error.response);
      console.error('错误消息:', error.message);
      if (error.response) {
        console.error('响应状态码:', error.response.status);
        console.error('响应数据:', error.response.data);
        message.error(`注册失败: ${error.response.data?.error || '未知错误'}`);
      } else if (error.request) {
        console.error('请求已发送但没有收到响应:', error.request);
        message.error('注册失败: 无法连接到服务器');
      } else {
        console.error('请求配置错误:', error.message);
        message.error(`注册失败: ${error.message}`);
      }
    } finally {
      setRegisterLoading(false);
    }
  };

  return (
    <div className="liquid-bg">
      <div className="login-form glass-card fade-in-up">
        <h1 className="login-form-title glow-title">发版系统</h1>
        <Tabs defaultActiveKey="login" className="glass-form">
          <TabPane tab="登录" key="login">
            <Form
              name="login"
              onFinish={handleLogin}
              layout="vertical"
            >
              <Form.Item
                name="username"
                label="用户名"
                rules={[{ required: true, message: '请输入用户名' }]}
              >
                <Input prefix={<UserOutlined />} placeholder="请输入用户名" />
              </Form.Item>
              
              <Form.Item
                name="password"
                label="密码"
                rules={[{ required: true, message: '请输入密码' }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="请输入密码" />
              </Form.Item>
              
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
                  登录
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
          <TabPane tab="注册" key="register">
            <Form
              name="register"
              onFinish={handleRegister}
              layout="vertical"
            >
              <Form.Item
                name="username"
                label="用户名"
                rules={[{ required: true, message: '请输入用户名' }]}
              >
                <Input prefix={<UserOutlined />} placeholder="请输入用户名" />
              </Form.Item>
              
              <Form.Item
                name="phone"
                label="手机号"
                rules={[{ required: true, message: '请输入手机号' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的中国手机号' }]}
              >
                <Input prefix={<PhoneOutlined />} placeholder="请输入手机号" />
              </Form.Item>
              
              <Form.Item
                name="password"
                label="密码"
                rules={[{ required: true, message: '请输入密码' }, { min: 6, message: '密码长度至少为6位' }]}
              >
                <Input.Password prefix={<LockOutlined />} placeholder="请输入密码" />
              </Form.Item>
              
              <Form.Item
                name="role_id"
                label="角色"
                initialValue={1}
              >
                <select style={{ width: '100%', height: '32px', padding: '0 8px' }}>
                  <option value="1">测试人员</option>
                  <option value="2">前端开发</option>
                  <option value="3">后端开发</option>
                  <option value="4">运维人员</option>
                  <option value="5">产品人员</option>
                  <option value="6">管理员</option>
                </select>
              </Form.Item>
              
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={registerLoading} style={{ width: '100%' }}>
                  注册
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default Login;
